import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { tokens } from '@/config/tokens';
import { useWithdraw } from '@/providers/WithdrawProvider';
import { i18n } from '@lingui/core';
import { Box, Button, Card, Flex, Group, Input, NumberFormatter, NumberInput, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';
import { CopyWalletButton } from '../CopyWalletButton';
import { TokenMenuDropdown } from '../TokenMenuDropdown';
import classes from './Withdraw.module.css';
import { WithdrawNotification } from './WithdrawNotification';
export const WithdrawTransaction: React.FC = () => {
  const {
    activeTab,
    setActiveTab
  } = useWithdraw();
  const token = useMemo(() => tokens.find(item => item.symbol === activeTab), [activeTab]);
  return <Stack gap={20}>
      <Card radius={5} bg="var(--bg-600)" mt={20} p={{
      base: 10,
      sm: 20
    }} style={{
      overflow: 'visible'
    }}>
        <Box>
          <Stack gap={10}>
            <Input size="md" rightSectionWidth={100} classNames={{
            input: classes.input
          }} value={`${token?.symbol} (${token?.name})`} style={{
            zIndex: 300
          }} rightSection={<TokenMenuDropdown logoURI={token?.logoURI} tokens={tokens} setActiveTab={setActiveTab} />} readOnly />

            <Group justify="space-between">
              <Text fz={12} c="var(--text-prime)" fw={500}>
                {token?.description}
              </Text>
              <Text fz={12} c="var(--text-grey-4)" fw={500}>
                {i18n._('6 confirmations')}
              </Text>
            </Group>
          </Stack>

          <Stack mt={40} gap={10}>
            <Flex direction={{
            base: 'column',
            sm: 'row'
          }} gap={20}>
              <Stack gap={4}>
                <Group c="var(--text-dark)" justify="space-between">
                  <Text fz={12} c="inherit" fw={700}>
                    {i18n._('ENTER AMOUNT')}
                  </Text>
                  <Text fz={12} c="var(--text-prime)">
                    <NumberFormatter value={1244077} thousandSeparator="," decimalSeparator="." />
                    <Text span inherit c="var(--text-dark)">
                      {i18n._(' available')}
                    </Text>
                  </Text>
                </Group>
                <NumberInput classNames={classes} rightSectionWidth={70} thousandSeparator="," decimalSeparator="." decimalScale={9} placeholder={i18n._('Amount')} rightSection={<Button variant="transparent" size="xs" c="var(--text-grey-4)" fz={13}>
                      {i18n._('Max')}
                    </Button>} />
              </Stack>

              <Stack gap={4} flex={1}>
                <Text tt="uppercase" fz={12} fw={700} c="var(--text-dark)">
                  {i18n._('ENTER YOUR ')}
                  <Text span inherit c="var(--text-prime)">
                    {token?.symbol}
                  </Text>
                  {i18n._(' WALLET')}
                </Text>

                <Input placeholder={i18n._('WALLET')} classNames={classes} rightSectionWidth={50} rightSection={<CopyWalletButton value={`${token?.address}`} />} />
              </Stack>
            </Flex>

            <Box>
              <Text c="var(--icon-primary)" fz={13}>
                {i18n._('Only deposit over the Ethereum network.')}
              </Text>
              <Text c="var(--icon-primary)" fz={13}>
                {i18n._('Do not use BSC/BNB, Base, Arbitrum, Optimism or others.')}
              </Text>
            </Box>
          </Stack>
        </Box>
      </Card>

      <WithdrawNotification />

      <Flex justify={{
      base: 'center',
      sm: 'right'
    }} mt={4}>
        <Button w={232} h={46} fz={13} classNames={btnStyle} leftSection={<Icons className="icon-pr-line-log-out" fontSize={24} />}>
          {i18n._('REQUEST WITHDRAWAL')}
        </Button>
      </Flex>
    </Stack>;
};